module.exports = __webpack_public_path__ + "img/card_franchise3.191afbc0.svg";